import VehicleForm from '../../../antd/vehicle/VehicleForm'
import { useParams } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import { getRequest } from '../../../services/base'
import { NavContext } from '../../../context/global_context'
import { Row, Space, Typography } from 'antd'
import Button from '../../../antd/common/Button'
import { downloadErrorLogs, downloadFileBlob } from '../../../utils/common'

const EditVehicle = () => {
  const [state, dispatch] = useContext(NavContext)
  const { vehicle } = useParams()
  const [vehicleDetails, setVehicleDetails] = useState({})
  const [error, setError] = useState('')

  useEffect(() => {
    getVehicleDetails()
  }, [])

  const getVehicleDetails = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Vehicle Data',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(`/api/vehicles/vehicle_details/${vehicle}/`)
    if (res?.msg) {
      setError(res?.msg)
    } else {
      setVehicleDetails(res)
      setError('')
    }
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const downloadJson = () => {
    let vehicle_meta_data = {
      make: vehicleDetails?.make,
      make_description: vehicleDetails?.make_description,
      model: vehicleDetails?.model,
      model_description: vehicleDetails?.model_description,
      year: vehicleDetails?.year,
      svg_enabled: vehicleDetails?.svg_enabled,
      phase:
        vehicleDetails?.phase?.toLowerCase() === 'null'
          ? null
          : vehicleDetails?.phase,
      tags: vehicleDetails?.vin_dependent_tags,
      svg: {
        stroke: vehicleDetails?.svg_stroke,
        fill: vehicleDetails?.svg_fill,
        resolution: vehicleDetails?.svg_resolution,
      },
      default_sales_codes: vehicleDetails?.default_option_code_data?.label,
      model_year_sales_code: vehicleDetails?.model_year_sales_code,
      make_model_id: vehicleDetails?.make_model_id,
      tester_id: vehicleDetails?.tester_id,
    }

    downloadFileBlob(
      new Blob([JSON.stringify(vehicle_meta_data)], {
        type: 'application/json',
      }),
      'meta.json'
    )
  }

  return (
    <div className="page edit-vehicle">
      <Row className="title">
        <Space size={'middle'}>
          <Typography.Title level={5}>Vehicle Details</Typography.Title>
        </Space>
        <Space size={'middle'}>
          <Button onClick={(e) => downloadJson()}>Download Meta Json</Button>
        </Space>
      </Row>
      <Row className="body">
        {error ? (
          error
        ) : (
          <VehicleForm
            vehicleDetails={vehicleDetails}
            setVehicleDetails={setVehicleDetails}
          />
        )}
      </Row>
    </div>
  )
}

export default EditVehicle
